export const myToysPage = {
    'my.toys.page.title': '我的玩具',
    'my.toys.page.toy.for.sale.modal.title': '玩具出售',
}
